'use client';

import useCroppedImageSet from '@/hooks/use-cropped-image-set';
import { CropConfigs } from '@weee-fe/module';
import Head from 'next/head';

const ImagePreload = ({ url, configs, imageKey }: { url: string; configs?: CropConfigs; imageKey: string }) => {
  const { imgUrlSet, imgUrl } = useCroppedImageSet({ url, configs });

  return (
    <Head>
      <link
        rel="preload"
        type="image"
        href={imgUrl}
        as="image"
        key={imageKey}
        {...{ imageSrcSet: `${imgUrlSet[0]} 1x, ${imgUrlSet[1]} 2x, ${imgUrlSet[2]} 3x` }}
      />
    </Head>
  );
};

export default ImagePreload;
